// src/components/CustomCheckbox.jsx
import { styled } from "@mui/material/styles"
import { Checkbox } from "@mui/material"

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  color: "#004f7d",
  "&.Mui-checked": {
    color: "#004f7d",
  },
}))

export default CustomCheckbox
